import React from 'react';
import { ChessAnalysisProvider } from './ChessAnalysisContext';

/**
 * Wrapper component that provides the ChessAnalysisContext to the application
 * This allows Board.jsx and Stockfish.js to share data
 */
const ChessAnalysisWrapper = ({ children }) => {
  return (
    <ChessAnalysisProvider>
      {children}
    </ChessAnalysisProvider>
  );
};

export default ChessAnalysisWrapper; 